// ─────────────────────────────────────────────────────────────────────────────
// BLOCO "FALE CONOSCO" NA HOME — formulário curto que vira lead no CRM.
//
// Sugestão #213 / SD-0020 (Mister Imóveis, cs1859): nome, telefone e o que procura,
// na própria home, para quem não quer abrir o WhatsApp.
//
// ⚠️ Este é o código dos ~300 sites: o pedido é de UM cliente, então o bloco mora
// numa allowlist, no padrão de `utils/homeProprietarios.ts`. Outro cliente é uma
// ENTRADA NOVA neste mapa, não um `if` novo espalhado pelo render. Quem não está no
// mapa recebe `null`: não ganha nenhum nó no HTML nem baixa o chunk do formulário.
// ─────────────────────────────────────────────────────────────────────────────

export type HomeFaleConoscoConfig = {
    /**
     * O bloco entra logo depois deste slot do miolo da home. Fica fora do contrato de
     * `lib/server/section-order.ts`: um slot novo exigiria mexer nos 4 espelhos da ordem
     * (deploy coordenado de 4 serviços) por causa de um bloco de 1 tenant. Como
     * `normalizeSectionOrder` nunca omite slot, o bloco acompanha o slot se a ordem mudar.
     */
    aposSlot: string;
    titulo: string;
    apoio: string;
    rotuloBusca: string;
    botao: string;
    sucessoTitulo: string;
    sucessoApoio: string;
    /** Origem do lead no CRM: é o que separa este formulário dos demais nos relatórios. */
    origem: string;
};

export const HOME_FALE_CONOSCO_BY_SITE: Record<number, HomeFaleConoscoConfig> = {
    // cs1859 — Mister Imóveis (misterimoveis.com.br). Entre as vitrines de imóveis e os
    // empreendimentos, dois blocos brancos: a faixa escura se destaca sem encostar no
    // "Quem somos", que também é escuro.
    1859: {
        aposSlot: 'card',
        titulo: 'Prefere que a gente fale com você?',
        apoio: 'Deixe seu nome e telefone e conte o que você procura. Um corretor da Mister Imóveis retorna em breve.',
        rotuloBusca: 'O que você procura?',
        botao: 'Pedir contato de um corretor',
        sucessoTitulo: 'Recebemos seu contato!',
        sucessoApoio: 'Um corretor da Mister Imóveis vai falar com você em breve.',
        origem: 'Formulário da home',
    },
};

export const getHomeFaleConosco = (site: any): HomeFaleConoscoConfig | null =>
    HOME_FALE_CONOSCO_BY_SITE[Number(site?.id)] ?? null;
